import { LoadingOverlay, LoadingOverlayProps } from '@mantine/core';

import { brand } from '../theme';
import { ZorroLoaderV2 } from '../v2/Loader/Loader';

export type ILoadingOverlayProps = LoadingOverlayProps;

export function ZorroLoadingOverlay({
  overlayProps,
  ...props
}: ILoadingOverlayProps) {
  return (
    <LoadingOverlay
      w="100vw"
      h="100%"
      pos="fixed"
      overlayProps={{
        blur: 2,
        opacity: 0.5,
        color: brand.zorroCoal900,
        ...overlayProps,
      }}
      loaderProps={{ children: <ZorroLoaderV2 /> }}
      {...props}
    />
  );
}
